import { allTrackers } from "app/services/track/track";

export const homepageTracking = {
    onSearchBarClick: (): void => {
        allTrackers.dispatchTrackEvent("Search Bar", "click", "Enter domain");
    },
    onSearchResultClick: (domain: string): void => {
        allTrackers.dispatchTrackEvent("Search Bar", "click", `search_results/Monitor & Protect/${domain}`);
    },
    onGetStartedClick: (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "Get Started/Monitor & Protect");
    },
};